import { Nullable } from '@/utils/types';
import { ITransactionLease, ITransactionSale, RentScheduleTypeEnum, TransactionTypeEnum } from '@/bundles/Comparables/types';

interface IComparableTransactionTypeLabelWithScheduleParams {
  transactionType: TransactionTypeEnum;
  investmentSale?: Nullable<boolean>;
  sublease?: Nullable<boolean>;
  scheduleType?: Nullable<RentScheduleTypeEnum>;
}

export const getComparableTransactionTypeLabelWithSchedule = ({
  transactionType,
  investmentSale,
  sublease,
  scheduleType,
}: IComparableTransactionTypeLabelWithScheduleParams): string => {
  const parts: string[] = [transactionType];

  if (investmentSale) {
    parts.push('Investment');
  } else if (sublease) {
    parts.push('Sublease');
  }

  if (!sublease && scheduleType) {
    parts.push(scheduleType);
  }

  return parts.join(' - ');
}

export const getComparableTransactionTypeLabel = (transaction: ITransactionSale | ITransactionLease) => {
  if ('investment_sale' in transaction && transaction.investment_sale) {
    return `${transaction.transaction_type} - Investment`;
  }

  if ('sublease' in transaction && transaction.sublease) {
    return `${transaction.transaction_type} - Sublease`;
  }

  return transaction.transaction_type;
}

export const getComparableTransactionImageLabel = (transaction: ITransactionSale | ITransactionLease) => {
  if ('investment_sale' in transaction && transaction.investment_sale) {
    return `Investment Sale`;
  }

  if ('sublease' in transaction && transaction.sublease) {
    return `Sublease`;
  }

  return transaction.transaction_type === TransactionTypeEnum.sale ? 'Sold' : 'Leased';
}
